import * as DG from 'datagrok-api/dg';
import { ALPHABET } from './consts';
import { splitterAsHelm, StringListSeqSplitted } from './utils';
export const SeqTemps = new class {
    constructor() {
        /** Column's temp slot name for a SeqHandler object */
        this.seqHandler = `seq-handler`;
        this.notationProvider = `seq-handler.notation-provider`;
    }
}();
export class SeqValueBase extends DG.SemanticValue {
    get value() { return this.seqHandler.column.get(this.rowIdx); }
    set value(v) { this.seqHandler.column.set(this.rowIdx, v); }
    get helm() { return this.seqHandler.getHelm(this.rowIdx); }
    isDna() { return this.seqHandler.alphabet === ALPHABET.DNA; }
    isRna() { return this.seqHandler.alphabet === ALPHABET.RNA; }
    isNaturalPeptide() { return this.seqHandler.alphabet === ALPHABET.PT; }
    isHelm() { return this.seqHandler.isHelm(); }
    constructor(rowIdx, seqHandler) {
        if (seqHandler.column.dataFrame == null)
            throw new Error('Attribute .dataFrame is required for SeqValueBase from cell');
        const tableCell = seqHandler.column.dataFrame.cell(rowIdx, seqHandler.column.name);
        const v = DG.SemanticValue.fromTableCell(tableCell);
        // @ts-ignore
        super(v.dart);
        this.rowIdx = rowIdx;
        this.seqHandler = seqHandler;
    }
    getSplitted() {
        return this.seqHandler.getSplitted(this.rowIdx);
    }
    getSplittedWithSugarsAndPhosphates() {
        if (!this.isDna() && !this.isRna())
            return this.getSplitted();
        const originalSplit = splitterAsHelm(this.helm);
        const fullArray = [];
        // heuristic for detecting dna/rna
        const helmNucleotideFullRe = /\(|\)/;
        for (let i = 0; i < originalSplit.length; i++) {
            const m = originalSplit.getOriginal(i);
            const splitM = m.split(helmNucleotideFullRe).filter((el) => !!el);
            if (splitM.length === 3) {
                fullArray.push(splitM[0]);
                fullArray.push(splitM[1]);
                fullArray.push(splitM[2]);
            }
            else
                fullArray.push(m);
        }
        return new StringListSeqSplitted(fullArray, this.seqHandler.defaultGapOriginal);
    }
}
//# sourceMappingURL=seq-handler.js.map